import { Input } from '@components/FormComponents';
import { Modal } from '@components/Modal/Modal';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { type ReactElement, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

export function ExitPreview(): ReactElement {
  const router = useRouter();
  return (
    <button
      type="button"
      onClick={() => {
        router.push('/api/exit-preview');
      }}
      className="fixed bottom-[80px] left-2.5 z-3 border-none bg-red p-4 text-white"
    >
      Exit Preview
    </button>
  );
}

export function SelectSplitTest(): ReactElement {
  const [cookieArray, setCookieArray] = useState<Array<[string, string]>>([]);
  const [showModal, setShowModal] = useState(false);

  const rhfMethods = useForm({
    mode: 'onTouched',
  });

  const vals = rhfMethods.watch();

  useEffect(() => {
    // update cookies when form values change
    if (vals['ab-optimize']) {
      for (const [key, value] of cookieArray) {
        const newValue = vals['ab-optimize'][key.split('.')[1]];
        Cookies.set(key, `${value.split('.')[0]}.${newValue}`);
      }
    }
  }, [vals, cookieArray]);

  const handleClick = () => {
    // 1. read in cookies
    const cookies = Cookies.get();

    // 2. Put the cookies into an array
    const cookieArray: Array<[string, string]> = [];
    for (const [key, value] of Object.entries(cookies)) {
      if (key.startsWith('ab-')) {
        cookieArray.push([key, value]);
      }
    }
    setCookieArray(cookieArray);
    setShowModal(true);
    // set the values into the form
    for (const [key, value] of cookieArray) {
      rhfMethods.setValue(key, Number.parseInt(value.split('.')[1]));
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className="bg-pink p-4 text-white"
      >
        Select Cookies
      </button>
      <Modal show={showModal} setShow={setShowModal}>
        <FormProvider {...rhfMethods}>
          <form>
            <h2>Select Cookies</h2>
            <ul>
              {cookieArray.map(([key, value]) => (
                <li key={key}>
                  <Input name={key} label={key} type="number" />
                </li>
              ))}
            </ul>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
}
